"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PointerChangesSyncDeployment = exports.SnapshotSyncDeployment = void 0;
const misc_1 = require("../misc");
const auth_chain_1 = require("../misc/auth-chain");
const validation_1 = require("../validation");
/**
 * @public
 */
var SnapshotSyncDeployment;
(function (SnapshotSyncDeployment) {
    SnapshotSyncDeployment.schema = {
        type: 'object',
        properties: {
            entityId: { type: 'string' },
            entityType: { type: 'string' },
            pointers: { type: 'array', items: { type: 'string' }, minItems: 1 },
            authChain: auth_chain_1.AuthChain.schema,
            entityTimestamp: { type: 'number', minimum: 0 }
        },
        oneOf: [{ properties: { entityId: misc_1.IPFSv1.schema } }, { properties: { entityId: misc_1.IPFSv2.schema } }],
        required: ['entityId', 'entityType', 'pointers', 'entityTimestamp', 'authChain']
    };
    SnapshotSyncDeployment.validate = (0, validation_1.generateLazyValidator)(SnapshotSyncDeployment.schema);
})(SnapshotSyncDeployment = exports.SnapshotSyncDeployment || (exports.SnapshotSyncDeployment = {}));
/**
 * @public
 */
var PointerChangesSyncDeployment;
(function (PointerChangesSyncDeployment) {
    PointerChangesSyncDeployment.schema = {
        type: 'object',
        properties: {
            entityId: { type: 'string' },
            entityType: { type: 'string' },
            pointers: { type: 'array', items: { type: 'string' }, minItems: 1 },
            authChain: auth_chain_1.AuthChain.schema,
            entityTimestamp: { type: 'number', minimum: 0 },
            localTimestamp: { type: 'number', minimum: 0 }
        },
        oneOf: [{ properties: { entityId: misc_1.IPFSv1.schema } }, { properties: { entityId: misc_1.IPFSv2.schema } }],
        required: ['entityId', 'entityType', 'pointers', 'localTimestamp', 'entityTimestamp', 'authChain']
    };
    PointerChangesSyncDeployment.validate = (0, validation_1.generateLazyValidator)(PointerChangesSyncDeployment.schema);
})(PointerChangesSyncDeployment = exports.PointerChangesSyncDeployment || (exports.PointerChangesSyncDeployment = {}));
//# sourceMappingURL=sync-deployments.js.map